import { createTheme, Fade } from '@mui/material';

let theme = createTheme();
theme = createTheme({
    typography: {
        "fontFamily": `"Poppins" `,
        logo: {
            fontFamily: 'Comforter',
            fontSize: 50,
            fontWeight: 700
        }
    },
    palette: {
        primary:{
            main: '#f43873',
            light: '#f43873'
        }, 
        secondary:{
            main: '#6c757d',
            light: '#6c757d'
        },
        blue: '#007bff',
        indigo: '#6610f2',
        purple: '#6f42c1',
        pink: '#e83e8c',
        darkPink: '#d3295e',
        red: '#dc3545',
        orange: '#fd7e14',
        yellow: '#ffc107',
        green: '#28a745',
        lightGreen: '#6ebf79',
        teal: '#20c997',
        cyan: '#17a2b8',
        white: '#fff',
        lightGray: 'rgb(108 117 125 / 42%)',
        gray: '#6c757d',
        grayDark: '#343a40',
        faint: 'rgb(228 228 228)',
        lavaOrange: '#ff8000',
        info: {
            main: '#17a2b8',
            light: '#17a2b8'
        },
        warning: {
            main: '#edbc04',
            light: '#edbc04'
        },
        danger: {
            main: '#dc3545',
            light: '#dc3545'
        },
        border: {
            main: 'rgba(219, 219, 219)',
            light: 'rgba(219, 219, 219)'
        },
        light: '#f8f9fa',
        dark: '#343a40',
        background: {
          card: '#fff',
          container: '#f2f2f2'
        }
    },
    components: {
        MuiGrid: {
            variants: [
                {
                    props: {variant: 'responsive'},
                    style: {
                        [theme.breakpoints.down('sm')] : {
                            flexDirection: "column-reverse"
                        }
                    }
                },
                {
                    props: { variant: 'fullbleed'},
                    style: {
                        width: '100%',
                    }
                }
            ]
        },
        MuiContainer: {
            variants: [
                {
                    props: { variant: 'fullbleed'},
                    style: {
                        minwidth: '100vw',
                        minHeight: '100vh',
                        padding: '0px 0px',
                        maxWidth: '100vw',
                        background: '#f2f2f2',
                        [theme.breakpoints.up('md')] : {
                            paddingTop: '0px',
                            paddingBottom: '0px',
                            paddingLeft: '0px',
                            paddingRight: '0px',
                        },
                        [theme.breakpoints.down('md')] : {
                            paddingTop: "0px",
                            paddingLeft: '0px',
                            paddingRight: '0px',
                        }
                    }
                },
                {
                    props: { variant: 'post'},
                    style: {
                        minwidth: '50vw',
                        width: '100%',
                        minHeight: '100vh',
                        padding: '0px 0px',
                        paddingTop: '200px',
                        paddingBottom: '300px',
                        maxWidth: '100vw',
                        background: '#f2f2f2'
                    }
                }
            ]
            
        }
        ,
        MuiAppBar: {
            variants: [
                {
                    props: { variant: 'darker'},
                    style: {
                        width: '100vw',
                        margin: '0px 0px',
                        borderRadius: '0px',
                        boxShadow: 'none',
                        top: '10px',
                        position: 'fixed',
                        zIndex: '1000',
                        backgroundColor: theme.palette.background.card,
                        [theme.breakpoints.down('sm')] : {
                            maxWidth: "100vw"
                        }
                    }
                }
            ]
            
        },
        MuiToolbar: {
            variants: [
                {
                    props: {variant: 'nav-bar'},
                    style: {
                        display: 'flex',
                        justifyContent: 'flex-end',
                        width: '400px',
                    }
                }
            ]
        },
        MuiCardMedia: {
            variants: [
                {
                    props: { variant: 'post'},
                    style: {
                        height: '250px'
                    }
                }
            ]
            
        },
        MuiButton: {
            variants: [
                {
                    props: {variant: 'main'},
                    style: {
                        padding: '10px 35px',
                        borderRadius: '50px',
                        backgroundColor: '#f43873',
                        color: '#fff',
                        fontFamily: 'Poppins',
                        textTransform: 'none',
                        '&:hover': {
                            color: '#fff',
                            backgroundColor: '#d3295e'
                        },
                        [theme.breakpoints.down('sm')] : {
                            padding: '8px 25px',
                        }
                    }
                
                },
                {
                    props: {variant: 'inverted'},
                    style: {
                        padding: '10px 35px',
                        borderRadius: '50px',
                        backgroundColor: '#fff',
                        color: '#f43873',
                        fontFamily: 'Poppins',
                        textTransform: 'none',
                        '&:hover': {
                            backgroundColor: 'rgb(228 228 228)',
                            //color: '#fff',
                        },
                        [theme.breakpoints.down('sm')] : {
                            padding: '5px 25px',
                        }
                    }
                
                },
                {
                    props: {variant: 'main-mobile'},
                    style: {
                        padding: '5px 25px',
                        borderRadius: '50px',
                        backgroundColor: '#f43873',
                        color: '#fff',
                        fontFamily: 'Poppins',
                        textTransform: 'none',
                        '&:hover': {
                            color: '#fff',
                            backgroundColor: '#d3295e'
                        }
                    }
                
                },
                {
                    props: {variant: 'faint'},
                    style: {
                        padding: '10px 35px',
                        borderRadius: '50px',
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        color: '#343a40',
                        fontFamily: 'Poppins',
                        textTransform: 'none',
                        '&:hover': {
                            color: '#fff',
                            backgroundColor: '#f43873' 
                        }
                    }
                
                },
                {
                    props: {variant: 'hollow'},
                    style: {
                        padding: '10px 35px',
                        borderRadius: '50px',
                        backgroundColor: 'white',
                        color: '#f43873',
                        fontFamily: 'Poppins',
                        textTransform: 'none',
                        border: '2px solid #f43873',
                        '&:hover': {
                            color: '#fff',
                            backgroundColor: '#f43873' 
                        }
                    }
                
                }
            ]
        },
        MuiOutlinedInput: {
            variants: [
                {
                    props: { variant: 'main'},
                    style: {
                        borderRadius: '50px', 
                    }
                }
            ]
        }
    }
});

export default theme; 